export interface OnboardingSection {
  id: string;
  path: string;
  title: string;
  description: string;
  icon: string;
  isRequired: boolean;
  isComingSoon: boolean;
  order: number;
}

export type SectionStatus = 'unseen' | 'in-progress' | 'complete';

export interface SectionProgress {
  status: SectionStatus;
  lastViewed?: string;
  lastSaved?: string;
}

export interface OnboardingProgress {
  sections: Record<string, SectionProgress>;
}

export const ONBOARDING_SECTIONS: OnboardingSection[] = [
  {
    id: 'medical-architecture',
    path: '/onboarding/medical-architecture',
    title: 'Medical History',
    description: 'Active conditions, past illnesses, and surgical history',
    icon: 'IconHeartbeat',
    isRequired: true,
    isComingSoon: false,
    order: 1,
  },
  {
    id: 'medications',
    path: '/onboarding/medications',
    title: 'Medications & Allergies',
    description: 'Current medications, supplements, and allergies',
    icon: 'IconPill',
    isRequired: true,
    isComingSoon: false,
    order: 2,
  },
  {
    id: 'matrix',
    path: '/onboarding/matrix',
    title: 'Family History',
    description: 'Family members and their health conditions',
    icon: 'IconUsers',
    isRequired: true,
    isComingSoon: false,
    order: 3,
  },
  {
    id: 'logistics',
    path: '/onboarding/logistics',
    title: 'Logistics',
    description: 'Insurance, pharmacy, and care team information',
    icon: 'IconClipboardList',
    isRequired: true,
    isComingSoon: false,
    order: 4,
  },
  {
    id: 'lifestyle',
    path: '/onboarding/lifestyle',
    title: 'Lifestyle Profile',
    description: 'Sleep, exercise, nutrition, and stress patterns',
    icon: 'IconActivity',
    isRequired: false,
    isComingSoon: true,
    order: 6,
  },
  {
    id: 'goals',
    path: '/onboarding/goals',
    title: 'Health Goals',
    description: 'Your longevity objectives and priorities',
    icon: 'IconTarget',
    isRequired: true,
    isComingSoon: true,
    order: 7,
  },
  {
    id: 'documents',
    path: '/onboarding/documents',
    title: 'Medical Records',
    description: 'Upload labs, imaging, clinical notes, and other medical documents',
    icon: 'IconFileUpload',
    isRequired: false,
    isComingSoon: false,
    order: 5,
  },
  {
    id: 'consent',
    path: '/onboarding/consent',
    title: 'Consent & Agreements',
    description: 'Review and sign required documents',
    icon: 'IconSignature',
    isRequired: true,
    isComingSoon: true,
    order: 8,
  },
];
